// src/chatgpt-config.js

const chatgptConfig = {
  apiKey: "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",
  endpoint: "https://api.openai.com/v1/chat/completions",
  model: "gpt-4o"
};

export default chatgptConfig;
